<zci-interstitial-page-content
    [backLink]="appRoutes.OWN_ACCOUNTS"
    [withOnlineFlow]="true"></zci-interstitial-page-content>
